import { render, staticRenderFns } from "./short-answer-question-component.vue?vue&type=template&id=4433d2aa&scoped=true&"
import script from "./short-answer-question-component.vue?vue&type=script&lang=ts&"
export * from "./short-answer-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./short-answer-question-component.vue?vue&type=style&index=0&id=4433d2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4433d2aa",
  null
  
)

export default component.exports